import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditMediaLogLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'EditMediaLog' */ './components/EditMediaLog')
);

export default (store) => {
	return {
		path: 'home/media-log/edit/:id',
		element: <AsyncLoading component={<EditMediaLogLazy />} />,
	};
};
